module.exports = __webpack_public_path__ + "static/media/diversity.9867ec86.md";